import React from 'react';
import { Card, CardContent } from './ui/card';
import { Star } from 'lucide-react';

const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Seattle, WA",
    rating: 5,
    text: "Sleep Whisper has been a game changer! I've struggled with insomnia for years, and this blend actually helps me relax and fall asleep naturally. Plus, it tastes amazing!",
    product: "Sleep Whisper"
  },
  {
    id: 2,
    name: "James K.",
    location: "Portland, OR",
    rating: 5,
    text: "The Elder & Fire blend got me through cold season without missing a day of work. Love supporting a local Washington business with such quality products!",
    product: "Elder & Fire"
  },
  {
    id: 3,
    name: "Maria G.",
    location: "Tacoma, WA",
    rating: 5,
    text: "I was skeptical about the name, but Mudbutt Brew delivers! The Cortisol Crush tea has helped me manage my stress levels tremendously. Highly recommend!",
    product: "Cortisol Crush"
  },
  {
    id: 4,
    name: "David R.",
    location: "Olympia, WA",
    rating: 4,
    text: "Great quality loose leaf teas. The brewing instructions are clear and easy to follow. My whole family enjoys different blends throughout the day.",
    product: "Multiple Products"
  },
  {
    id: 5,
    name: "Emily T.",
    location: "Bellingham, WA",
    rating: 5,
    text: "The Gut Glow blend has made such a difference in my digestion. Love that all the ingredients are natural and ethically sourced. Will definitely order again!",
    product: "Gut Glow"
  },
  {
    id: 6,
    name: "Mike B.",
    location: "Spokane, WA",
    rating: 5,
    text: "Gray Beard Mountain Hunter is my new morning ritual. Perfect amount of caffeine and the flavor is incredible. Beats coffee any day!",
    product: "Gray Beard Mountain Hunter"
  }
];

export const Testimonials = () => {
  const renderStars = (rating) => {
    return [...Array(5)].map((_, index) => (
      <Star
        key={index}
        className="w-4 h-4"
        fill={index < rating ? '#c2a357' : 'none'}
        style={{ color: '#c2a357' }}
      />
    ));
  };

  return (
    <section id="testimonials" className="py-20" style={{ backgroundColor: 'white' }}>
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2
            className="text-4xl md:text-5xl font-bold mb-4"
            style={{ 
              color: '#5e3a1c',
              fontFamily: 'Georgia, serif'
            }}
          >
            What Our Customers Say
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#8b5c2f' }}>
            Real reviews from real people who love Mudbutt Brew
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card
              key={testimonial.id}
              className="border-2 hover:shadow-xl transition-all duration-300"
              style={{ borderColor: '#c2a357' }}
            >
              <CardContent className="pt-6">
                <div className="flex gap-1 mb-4">
                  {renderStars(testimonial.rating)}
                </div>
                
                <p className="text-base mb-4 italic" style={{ color: '#5e3a1c' }}>
                  "{testimonial.text}"
                </p>
                
                <div className="border-t pt-4" style={{ borderColor: '#c2a357' }}>
                  <p className="font-bold" style={{ color: '#5e3a1c' }}>
                    {testimonial.name}
                  </p>
                  <p className="text-sm" style={{ color: '#8b5c2f' }}>
                    {testimonial.location}
                  </p>
                  <p className="text-xs mt-1 font-semibold" style={{ color: '#3a692b' }}>
                    {testimonial.product}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg mb-4" style={{ color: '#8b5c2f' }}>
            Want to share your experience?
          </p>
          <a
            href="#contact"
            className="inline-block px-8 py-3 rounded-md font-semibold hover:opacity-80 transition-opacity"
            style={{ backgroundColor: '#8b5c2f', color: '#f5e9d0' }}
          >
            Leave a Review
          </a>
        </div>
      </div>
    </section>
  );
};
